import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { WorkqueueService } from '../../../BaseFramework/core/http/workqueue.service';


import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, UntypedFormBuilder, FormControl, UntypedFormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-claims-activity-timeline',
  templateUrl: './claims-activity-timeline.component.html',
  styleUrls: ['./claims-activity-timeline.component.scss']
})
export class ClaimsActivityTimelineComponent implements OnInit {
  _currentComponentName = 'ClaimsActivityTimelineComponent'

  constructor(private viewContainerRef: ViewContainerRef,
    public validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: UntypedFormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private workQueueService: WorkqueueService,
    public appMetadataHandler: AppMetadataHandler,
    public msg : NzMessageService
  ) { }

  //Declaraions which might need developer input
  claimsActivityTimeLineForm: UntypedFormGroup
  CLAIMSACTIVITYTIMELINEFORM = "claimsActivityTimeLineForm"
  selectorOfThisComponent = 'app-claims-activity-timeline'
  parentEvent$

  workFlowAudit: any = [];
  correspondence: any = [];
  workFlowCorrs :any = [];
  selectViewType: any; 

  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  @Input() DO: any;
  @Input() transactionState: any;
  private _extractElementFromArray
  @Input()
  set ExtractElementFromArray(value) {
    this._extractElementFromArray = value
  }
  get ExtractElementFromArray() {
    return this._extractElementFromArray
  }
  @Input() maxDepth : number = 0
  private _IO = null;
  @Input()
  set IO(value: any) {
    if(value){
      this._IO = value;
      this.getWorkflowAudit(this._IO);
      this.getCorrespondenceDetails(this._IO);
      this.findViewByviewType();
    }
  };

  get IO() {
    return this._IO;
  }


  viewType = [
    { "key": "Everything", "value": "Everything" },
    { "key": "WorkflowAudit", "value": "Workflow Audit" },
    { "key": "Correspondence", "value": "Customer Correspondence" }
  ]

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
      
    } catch (error) {
      
    }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
      
    } catch (error) {
      
    }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      this.EmitComponentOutput(null);
    })
  }

  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);
    return true
  }


  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    if (this.IO != null) this.initializeClientSearchForm(this.IO)
    // this.subscribeToParentEvent();
    // this.getWorkflowAudit(this._IO);
  }

  initializeClientSearchForm(data?) {
    let payload = data || {}
    this.claimsActivityTimeLineForm = this.fb.group({
    });
  }

  isRequired(fieldName) {
    let returnObj = this.validationUtilService.isRequired(fieldName, this.CLAIMSACTIVITYTIMELINEFORM)
    return returnObj
  }


  getDateNowString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate, ['DD-MM-YYYY', 'X']).fromNow();
    }
    else {
      dateString = '-'
    }
    return dateString
  }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format('DD MMM YYYY hh:mm A');
    }
    else {
      dateString = '-'
    }
    return dateString
  }

  getDayDifference(startDt, endDt) {

    var start = moment(startDt, ['X', 'x', 'DD-MM-YYYY']);
    var end = moment(endDt, ['X', 'x', 'DD-MM-YYYY']);
    // return end.from(start, true);

    var time = endDt - startDt;
    var seconds = moment.duration(time).seconds();
    var minutes = moment.duration(time).minutes();
    var hours = moment.duration(time).hours();
    var days = moment.duration(time).days();

    if (days == 0 && hours == 0)
      return minutes + " minutes " + seconds + " seconds";
    else
      return days + " days " + hours + " hours " + minutes + " minutes " + seconds + " seconds";
  }

  getHourDifference(startDt, endDt) {
    var start = moment(startDt, ['X']);
    var end = moment(endDt, ['X']);
    return end.from(start, true);

  }

  findViewByviewType() {
    this.selectViewType = this.viewType ? this.viewType[0] ? this.viewType[0].key : null : null;
    this.mergeWorkflowCorrData();
  }

  getWorkflowAuditSubject$ = null
  getWorkflowAudit(IO) {
    if (IO != null) {
      let trnGuid = null;
      if(this.ExtractElementFromArray && this.commonUtilty.isArrayIterable(IO[this.DO])){
        trnGuid = IO[this.DO][this.maxDepth]? IO[this.DO][this.maxDepth]['guid'] : null;
      }
      else if(this.DO){
        trnGuid = IO[this.DO] ? IO[this.DO]['guid'] ? IO[this.DO]['guid'] : null : null;
      }
      else{
        let DO = this.commonUtilty.getDOName(IO);
        if(DO){ trnGuid = IO[DO] ? IO[DO]['guid'] ? IO[DO]['guid'] : null : null;}
        else trnGuid = IO['guid'] ? IO['guid'] : null;
      }
      if (trnGuid && trnGuid != null) {
        if (this.getWorkflowAuditSubject$) this.getWorkflowAuditSubject$.unsubscribe()
        //TODO check with Ninad about two parameters
        this.getWorkflowAuditSubject$ = this.workQueueService.getWorkflowAudit(trnGuid, "").subscribe(resp => {
          this.workFlowAudit = resp;
          try {
            this.workFlowAudit = this.commonUtilty.sortDateObject('createdDt', this.workFlowAudit, 'desc')
          }
          catch{

          }
          if(this.workFlowAudit && this.commonUtilty.isArrayIterable(this.workFlowAudit)){
            this.workFlowAudit.forEach(item => {
              switch (item.status.toLowerCase()) {
                case "completed": {
                  item.color = "green";
                  item.type = "workflow";
                  break;
                }
                case "pending": {
                  item.color = "orange";
                  item.type = "workflow";
                  break;
                }
                default: {
                  console.log("Invalid choice");
                  break;
                }
              }
            });
          }
        },
          (error) => {
            throw " Something went wrong";
          }
        );
      }
    }
  }


  getCorrespondenceDetails(IO) {
    if (IO && IO.correspondences) {
      this.correspondence = IO.correspondences
      this.correspondence.forEach(item => {
        switch (item.statusCd.toLowerCase()) {
          case "completed": {
            item.color = "green";
            item.type = "correspondence";
            break;
          }
          case "pending": {
            item.color = "orange";
            item.type = "correspondence";
            break;
          }
          case "verified": {
            item.color = "green";
            item.type = "correspondence";
            break;
          }
          default: {
            console.log("Invalid choice");
            break;
          }
        }
      });
    }
  }


  mergeWorkflowCorrData() {

    if (this.selectViewType === "Everything") {
      this.workFlowCorrs = []
      this.workFlowCorrs.push(...this.workFlowAudit);
      this.workFlowCorrs.push(...this.correspondence);
    }
    if (this.selectViewType === "WorkflowAudit") {
      this.workFlowCorrs = []
      this.workFlowCorrs.push(...this.workFlowAudit);
    }
    if (this.selectViewType === "Correspondence") {
      this.workFlowCorrs = []
      this.workFlowCorrs.push(...this.correspondence);
    }

    this.workFlowCorrs = this.commonUtilty.sortDateObject('startDt', this.workFlowCorrs, 'desc');


  }

  remarksModal = false;
  remarksByData = null;
  remarksForData = null;
  viewRemarks(remarksBy: any | null, remarksFor: any | null, ) {
    this.remarksModal = true;
    this.remarksByData = remarksBy;
    this.remarksForData = remarksFor;
  }

  cancelRemarks() {
    this.remarksModal = false;
  }

  getTatInHours(totalMinutes) {
    if (totalMinutes) {

      if (typeof totalMinutes == 'string')
        totalMinutes = parseInt(totalMinutes);
      var hours = Math.floor(totalMinutes / 60);
      var minutes = totalMinutes % 60;
      return (hours + " Hours " + minutes + " Minutes")
    }
    else
      return "-"


  }
}